const DEVELOPMENT_DOMAIN = 'http://localhost:8082';
const PRODUCTION_DOMAIN = 'https://monorail-edge.shopifysvc.com';
const PRODUCE_BATCH_ENDPOINT = '/unstable/produce_batch';
const PRODUCE_ENDPOINT = '/v1/produce';
function extractDomain(urlString) {
  return `https://${new URL(urlString).hostname}`;
}

export { DEVELOPMENT_DOMAIN, PRODUCE_BATCH_ENDPOINT, PRODUCE_ENDPOINT, PRODUCTION_DOMAIN, extractDomain };
